import React from "react";

const ConfirmDeleteModal = ({ onClose, onDelete, coupon }) => {
  if (!coupon) return null; // Ensure coupon data is passed and exists

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-md shadow-lg w-1/3 max-w-md">
        <h2 className="text-xl font-bold text-center">Confirm Deletion</h2>
        <p className="mt-2 text-center">
          Are you sure you want to delete the coupon "{coupon.name}"?
        </p>
        <div className="flex justify-around mt-4">
          <button
            className="bg-gray-500 text-white p-2 rounded-md"
            onClick={onClose} // Close modal without deleting
          >
            Cancel
          </button>
          <button
            className="bg-red-500 text-white p-2 rounded-md"
            onClick={onDelete} // Proceed with deletion
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
